import { Tooltip } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import { muiTheme } from 'mui-theme'

export const WarningTooltip: React.FC<{
  title: React.ReactNode
}> = ({ title, ...rest }) => {
  return (
    <Tooltip arrow placement="top" title={title}>
      <Icon
        css={{
          color: muiTheme.palette.warning.main
        }}
        icon="warning"
        {...rest}
      />
    </Tooltip>
  )
}
